import { render } from "./SectionEditView.vue?vue&type=template&id=125c56b2"
import script from "./SectionEditView.vue?vue&type=script&lang=js"
export * from "./SectionEditView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__